import React, { useState, useEffect, useContext, createContext, useCallback, Children, cloneElement } from "react";
import PropTypes from "prop-types";
import { mediaSort, getMediaType } from "../../utils/media-sorting.js";
import { usePinObject } from "../room/object-hooks.js";
import { getDisplayString, getIs2D } from "../room/useObjectList.js";

const ObjectSettingContext = createContext();

export function ObjectSettingsProvider({ hubChannel, scene, children }) {
  // const [objects, setObjects] = useState([]);
  // const [focusedObject, setFocusedObject] = useState(null); // The object currently shown in the viewport
  const [selectedObject, setSelectedObject] = useState(null); // The object currently selected in the object list
  const cameraSystem = scene.systems["hubs-systems"].cameraSystem;
  const [lightsEnabled, setLightsEnabled] = useState(cameraSystem.lightsEnabled);

  const handleSelectedObject = useCallback(e => {
    const el = e.detail;

    setSelectedObject({
      id: el.object3D.id,
      name: getDisplayString(el),
      type: getMediaType(el),
      el: el,
      is2D: getIs2D(el)
    });
  }, []);

  useEffect(() => {
    window.addEventListener("open-object-settings", handleSelectedObject);
  }, []);

  const togglePersistency = useCallback(e => {}, []);

  const context = {
    // objects,
    handleSelectedObject,
    activeObject: selectedObject,
    // focusedObject,
    selectedObject,
    lightsEnabled,
    togglePersistency
  };

  // Note: If we move ui-root to a functional component and use hooks,
  // we can use the useObjectList hook instead of cloneElement.

  return <ObjectSettingContext.Provider value={context}>{children}</ObjectSettingContext.Provider>;
}

ObjectSettingsProvider.propTypes = {
  scene: PropTypes.object.isRequired,
  children: PropTypes.node
};

export function useObjectSettings() {
  return useContext(ObjectSettingContext);
}
